import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { TPwaInstallMode } from '../../../interfaces/pwa-install.types';
import { PwaInstallService } from '../../../services/pwa/pwa-install.service';
import { PwaInstallInstructionsDialogComponent } from './pwa-install-instructions-dialog.component';

@Component({
    selector: 'app-pwa-install-button',
    templateUrl: './pwa-install-button.component.html',
    styleUrls: ['./pwa-install-button.component.scss'],
    standalone: false,
})
export class PwaInstallButtonComponent {
    @Input() public appearance: 'auth' | 'menu' = 'auth';
    @Output() public installRequested = new EventEmitter<void>();

    public readonly mode$: Observable<TPwaInstallMode>;
    public isProcessing = false;

    public constructor(
        private readonly pwaInstallService: PwaInstallService,
        private readonly dialog: MatDialog,
    ) {
        this.mode$ = this.pwaInstallService.mode$;
    }

    public async install(mode: TPwaInstallMode): Promise<void> {
        if (this.isProcessing) {
            return;
        }

        this.isProcessing = true;
        this.installRequested.emit();

        try {
            if (mode !== 'native' && this.appearance === 'menu') {
                await new Promise<void>((resolve) => setTimeout(resolve));
            }

            const outcome = await this.pwaInstallService.install();

            if (outcome === 'instructions-shown') {
                this.dialog.open(PwaInstallInstructionsDialogComponent, {
                    width: 'calc(100vw - 2rem)',
                    maxWidth: '26rem',
                    autoFocus: 'first-tabbable',
                    restoreFocus: true,
                    ariaLabel: 'Инструкция по установке приложения',
                    data: {
                        platform:
                            mode === 'ios-instructions' ? 'ios' : 'android',
                    },
                });
            }
        } finally {
            this.isProcessing = false;
        }
    }
}
